import { motion } from 'framer-motion';

export default function ReorderHandle({ visible, dragControls }) {
  if (!visible) return null;

  return (
    <motion.div
      onPointerDown={(e) => {
        e.preventDefault();
        dragControls?.start(e);
      }}
      initial={{ opacity: 0, x: -8 }}
      animate={{ opacity: 0.45, x: 0 }}
      exit={{ opacity: 0, x: -8 }}
      transition={{ type: 'spring', stiffness: 500, damping: 36 }}
      whileHover={{ opacity: 0.85, scale: 1.1 }}
      whileTap={{ scale: 0.88, opacity: 1 }}
      style={{
        touchAction: 'none',
        cursor: 'grab',
        flexShrink: 0,
        width: 24,
        padding: '6px 2px 6px 0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3.5,
        userSelect: 'none',
        WebkitUserSelect: 'none',
        color: 'currentColor',
      }}
    >
      {[0, 1, 2].map(i => (
        <motion.div
          key={i}
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          exit={{ scaleX: 0, opacity: 0 }}
          transition={{
            type: 'spring',
            stiffness: 600,
            damping: 30,
            delay: i * 0.05,
          }}
          style={{
            width: 14,
            height: 2.5,
            borderRadius: 2,
            background: 'currentColor',
            transformOrigin: 'left center',
          }}
        />
      ))}
    </motion.div>
  );
}
